import styled from 'styled-components'
import { Tabs, Tab } from '@mui/material'
import { useLocation, NavLink, Link } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { ClientRoute } from 'routes/client'

interface Props {
  children: JSX.Element
}

export default function ClubsAndCoursesContainer({ children }: Props): JSX.Element {
  const location = useLocation()
  const intl = useIntl()

  return (
    <PageContainer>
      <ActionContainer>
        <TabContainer value={location.pathname}>
          <Tab
            component={NavLink}
            to={ClientRoute.ADMIN_CLUB_SEARCH}
            value={ClientRoute.ADMIN_CLUB_SEARCH}
            label={<FormattedMessage id="strings.clubs" />}
            end
          />
          <Tab
            component={NavLink}
            to={ClientRoute.ADMIN_COURSE_SEARCH}
            value={ClientRoute.ADMIN_COURSE_SEARCH}
            label={<FormattedMessage id="strings.courses" />}
            end
          />
        </TabContainer>
        <LinkContainer>
          <Link to={ClientRoute.ADMIN_COURSE_GPS_EDITOR('')} target="_blank">
            <OpenGpsEditor>{intl.formatMessage({ id: 'strings.openGpsEditor' })}</OpenGpsEditor>
          </Link>
        </LinkContainer>
      </ActionContainer>

      <Content>{children}</Content>
    </PageContainer>
  )
}

const PageContainer = styled.div`
  padding-top: 10px;
  min-height: 500px;
  width: 100%;
  background-color: ${(props) => props.theme.customPalette.lightGray};

  & a {
    color: ${(props) => props.theme.palette.primary.main};
    text-decoration: none;
  }
`

const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 40px;
`

const TabContainer = styled(Tabs)`
  width: 50%;
  min-height: 40px;

  & .MuiTabs-indicator {
    height: 0;
  }

  & a {
    background-color: ${(props) => props.theme.customPalette.mediumGray};
    color: #242424;
    border-radius: 9px 9px 0 0;
    min-height: 40px;
    text-transform: none;

    &.active {
      background-color: ${(props) => props.theme.customPalette.light};
      color: ${(props) => props.theme.palette.primary.main};
    }
  }
`

const Content = styled.div``

const LinkContainer = styled.div`
  margin-top: -10px;
`

const OpenGpsEditor = styled.div`
  background-color: ${(props) => props.theme.customPalette.light};
  color: ${(props) => props.theme.palette.primary.main};
  border: 2px solid;
  border-color: ${(props) => props.theme.palette.primary.main};
  border-radius: 6px;
  font-weight: 700;
  padding: 10px 20px;
`
